
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.69 10.22c.163.327.338.584.525.77l2.17 2.135h-1.96L3.01 20.44h20.23l-2.415-7.315h-1.96l2.17-2.135c.187-.186.362-.443.525-.77h.315c.676 0 1.13.339 1.365 1.015l2.94 8.75c.018.075.03.187.034.336l.036 7.399c0 .397-.146.74-.437 1.033a1.417 1.417 0 01-1.033.437H1.47c-.397 0-.741-.146-1.032-.437A1.414 1.414 0 010 27.72l.016-6.499c.005-.52.011-.781.019-.781l.006-.224c.005-.098.015-.175.029-.231l2.94-8.75c.233-.676.688-1.015 1.365-1.015h.315zM13.125 0c.397 0 .74.146 1.033.438.29.292.437.636.437 1.032v9.765l3.325-3.36c.256-.256.607-.385 1.05-.385.42 0 .758.129 1.015.385.28.28.42.625.42 1.033s-.14.752-.42 1.032l-6.86 6.825-6.86-6.825c-.28-.28-.42-.624-.42-1.032s.14-.753.42-1.033c.28-.28.618-.42 1.015-.42.42 0 .77.14 1.05.42l3.325 3.36V1.47c0-.396.145-.74.437-1.032S12.728 0 13.125 0z","fill-rule":"evenodd","clip-rule":"evenodd"}})])
          )
        }
      }
    